import React, { Component } from "react";
import styled from "styled-components";
import { observer } from "mobx-react";
import { graphql, compose } from "react-apollo";
import { queryGetMe, mutationUpdateAgentManagement } from "Apollo";
import Popover from "module-common/Popover";
import { LocaleProvider, Checkbox, TimePicker, Calendar } from "antd";
import InputDate from "module-common/Input";
import moment from "moment";
import enUS from "antd/lib/locale-provider/en_US";

export default compose(
  graphql(queryGetMe, { name: "agent" }),
  graphql(mutationUpdateAgentManagement)
)(
  observer(
    class ModuleSupervisorSetting extends Component {
      state = { dateTime: moment() };

      componentWillReceiveProps(nextProps) {
        this.setState({ dateTime: moment(nextProps.value) });
      }

      onSave = value => {
        this.props.dateTime(this.state.dateTime);
        this.popover.hide();
      };

      onSelect = date => {
        this.setState({ dateTime: date });
      };

      onPanelChange = date => {
        this.setState({ dateTime: date });
      };

      onChangeTime = time => {
        this.setState({ dateTime: time });
      };

      render() {
        const dateTime = this.state.dateTime;

        return (
          <LocaleProvider locale={enUS}>
            <Popover
              {...this.props}
              ref={ref => (this.popover = ref)}
              margin={10}
              position="bottom"
              show="click"
              hide="manual"
              content={
                <Wrapper>
                  <WrapperDateTime>
                    <DateCalendar>
                      <div
                        style={{
                          width: 300,
                          border: "1px solid #d9d9d9",
                          borderRadius: 4
                        }}
                      >
                        <Calendar
                          fullscreen={false}
                          value={dateTime}
                          onSelect={this.onSelect}
                          onPanelChange={this.onPanelChange}
                        />
                      </div>
                    </DateCalendar>
                    <DatePick>
                      {/* 
                      <DisplayDate
                        labelWidth={100}
                        height={100}
                        value={
                          selectedValue &&
                          selectedValue.format("YYYY-MM-DDTHH:mm:ss")
                        }
                      /> 
                      */}
                      <TimePicker
                        value={dateTime}
                        onChange={this.onChangeTime}
                      />
                      {/* 
                      <Checkbox
                        value="{this.state.checkNick}"
                        onChange={this.handleChange}
                      >
                        email me when message is sent
                      </Checkbox> 
                      */}
                      <WrapBtn>
                        <SaveButton onClick={this.onSave}>SAVE</SaveButton>
                        <CancelButton onClick={() => this.popover.hide()}>
                          CANCEL
                        </CancelButton>
                      </WrapBtn>
                    </DatePick>
                  </WrapperDateTime>
                </Wrapper>
              }
            >
              {this.props.children}
            </Popover>
          </LocaleProvider>
        );
      }
    }
  )
);
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #d2d3d5;
  flex: 1;
  border-radius: 4px;
  margin-top: 25px;
  margin-left: -400px;
  padding-left: 30px;
  padding-right: 15px;
  &:after {
    content: " ";
    position: absolute;
    border: 12px solid;
    bottom: 100%;
    top: 1px;
    left: 44%;
    border-color: transparent #d2d3d5 transparent transparent;
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
  }
`;
const WrapperDateTime = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  background-color: white;
  margin: 14px 20px 15px;
  border-radius: 4px;
`;
const DateCalendar = styled.div`
  flex: 1;
  box-shadow: ${props => props.theme.shadow};
`;
const DatePick = styled.div`
  background-color: #d2d3d5;
  display: flex;
  flex: 1;
  padding: 20px;
  flex-direction: column;
`;
const DisplayDate = styled(InputDate)`
  margin-left: 0;
  margin-bottom: 6px;
  padding: 4px 0 4px 8px;
  width: 100px;
`;
const WrapBtn = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-items: space-between;
  margin-top: 20px;
`;
const SaveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  border-radius: 20px;
  color: white;
  transition: 0.3s;
  cursor: pointer;
  font-size: 0.8rem;
  padding: 5px 26px;
  margin-right: 10px;
  background-color: ${props => props.theme.blueButton};
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.7;
  }
`;
const CancelButton = SaveButton.extend`
  background-color: gray;
  padding: 5px 20px;
`;



// WEBPACK FOOTER //
// ./src/module-schedule/PickDateTime.js